import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { TipoDocumento } from '@shared/models';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_TIPO_DOC = '/tipo-documento';

@Injectable({
  providedIn: 'root',
})
export class TipoDocumentoService {
  private readonly API_URL_TIPO_DOC = API_URL + ENDPOINT_TIPO_DOC;
  private http = inject(HttpClient);

  listarTipoDoc(): Observable<TipoDocumento[]> {
    return this.http.get<ResponseWrapper<TipoDocumento[]>>(this.API_URL_TIPO_DOC).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
